import type {ReactAction} from '@netx/core/bootstrap';
import {faTrashAlt} from '@fortawesome/pro-solid-svg-icons';
import {canDeleteCurrentCartAssets} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';

/**
 * Delete cart assets
 * @param params
 * @returns Action
 */
export const cartActionDelete = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-current-delete',
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.DELETE),
	enableTest: canDeleteCurrentCartAssets,
	icon: faTrashAlt,
	get label() {
		return CART_CURRENT_ACTION_LABELS.DELETE;
	},
	...params,
});

export default cartActionDelete;
